<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img style="max-height: 75px" v-lazy="dados_concurso.logo_cliente">
                  </a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
                </div>
              </div>
            </div>
            <div class="text-center mt-5 pt-3">
              <h3>Envio de Títulos e Análise de Experiência Profissional
              </h3>
              <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>{{ dados_concurso.nome_cliente }}
              </div>
              <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>{{ dados_concurso.nome_concurso }}
              </div>
            </div>
            <div class="mt-5 py-3 border-top text-center">
              <h5>Dados do Candidato</h5>
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <h6 class="text-left"><b>Nome: </b>{{ dados_candidato.nome }}</h6>
                  <h6 class="text-left"><b>Número de Inscrição: </b>{{ dados_candidato.num_cand }}</h6>
                  <h6 class="text-left"><b>Email: </b>{{ dados_candidato.email }}</h6>
                  <h6 class="text-left"><b>Cargo: </b>{{ dados_candidato.cargo }}</h6>
                </div>
              </div>

              <!--              2204 EBSERH EXPLICACAO-->
              <div v-if="dados_concurso.concurso.indexOf('2204')===0" class="row">
                <div class="col-md-12">
                  <h5><b>IMPORTANTE!</b></h5>
                  <h6>Acesse o tutorial abaixo e leia atentamente antes de iniciar o cadastramento</h6>
                  <base-button>
                    <a class="button" target="_blank" style="color:white"
                       :href="estrutura_titulos.estrutura[0].link_tutorial">Abrir
                      Tutorial</a>
                  </base-button>
                </div>
              </div>
<!--https://fs.ibfc.org.br/arquivos/Tutorial Prova de Títulos - Nível Superior.pdf-->
<!--https://fs.ibfc.org.br/arquivos/Tutorial_Prova_de_Títulos-Nível_Médio.pdf-->
            </div>

            <div v-for="titulo in estrutura_titulos.estrutura" :key="titulo.id"
                 v-bind:class="titulo.id ==='requisito' ? '' : bloqueia_requisito "
                 class=" mt-1 py-4 border-top text-center">
              <div class=" row justify-content-center">
                <div class="col-md-12">
                  <h5 style="background-color: #052c3c;color: white">{{ titulo.nome }}</h5>
                  <pre style="word-wrap: break-word;white-space: pre-wrap;">{{ titulo.explicacao }}</pre>
                </div>
                <div class="row my-4 justify-content-center ">
                  <div class=" col-md-4 mr-4 ">
                    <base-dropdown>
                      <base-button slot="title" type="secundary" class="dropdown-toggle ">
                        {{
                          pontuacao_escolhida[titulo.id] === undefined ?
                              'Clique para escolher' : pontuacao_escolhida[titulo.id].descricao
                        }}
                      </base-button>
                      <li @click="seta_pontuacao(titulo.id,ponto)" v-for="ponto in titulo.pontuacao" :key="ponto.pontos"
                          :value="titulo.descricao" class="dropdown-item">
                        {{ `${ponto.descricao}` }}
                      </li>
                    </base-dropdown>
                  </div>
                  <div style="white-space:normal" class="ml-0 pl-0 col-md-4 text-left">
                    <h6>{{ titulo.descricao }}</h6>
                  </div>
                </div>
              </div>


              <!--Regiao do 2002 sejuf que possui um campo extra em determinados items-->
              <div v-if="titulo.extra" class="row my-4 justify-content-center ">
                <div class=" col-md-4 mr-4 ">
                  <base-dropdown>
                    <base-button style="white-space:normal" slot="title" type="secundary" class="dropdown-toggle ">
                      {{
                        sejuf_area[titulo.id] === undefined ?
                            'Clique para escolher' : sejuf_area[titulo.id]
                      }}
                    </base-button>
                    <li @click="seta_pontuacao_2002_sejuf(titulo.id,item)" v-for="item in titulo.extra.areas"
                        :key="item"
                        :value="item" class="dropdown-item">
                      {{ `${item}` }}
                    </li>
                  </base-dropdown>
                </div>
                <div style="white-space:normal" class="ml-0 pl-0 col-md-4 text-left">
                  <h6>{{ titulo.descricao }}</h6>
                </div>
              </div>


              <div class="py-2 row justify-content-center">
                <div class="col-lg-9">
                  <ExpProInput v-on:exp_pro_atualizacao="atualiza_registros(titulo.id,$event)"
                               :tipo_arquivo="titulo.id"></ExpProInput>
                </div>
              </div>

              <div class="py-2 row justify-content-center">
                <div class="col-lg-9">
                  <div class="field">
                    <h6 class="text-justify"><b>Instruções:</b> Arraste e solte no quadro abaixo, ou clique no quadro
                      para
                      selecionar as imagens desejadas. Serão aceitos somente arquivos .pdf, .jpg, .jpeg ou .png
                    </h6>
                    <vue-dropzone v-on:vdropzone-sending="fileAdded(titulo.id,...arguments)"
                                  :ref="`drop_titulo_${titulo.id}`"
                                  :id="`drop_titulo_${titulo.id}`"
                                  :options="dropzoneOptions"></vue-dropzone>
                  </div>
                </div>
              </div>
            </div>


            <div v-bind:class="bloqueia_requisito" class="mt-1 py-4 border-top text-center">
              <div class="btn_enviar row justify-content-center">
                <div class="col-lg-9">
                  <div class="btnConfirmacao">
                    <base-checkbox class="mb-3" v-model="btnConfirmacao">
                      <b>Declaro que as informações acima estão corretas e são verdadeiras.</b>
                    </base-checkbox>
                  </div>
                  <base-button :disabled="!btnConfirmacao" @click="envia_arquivos" native-type="submit"
                               type="primary" class="my-4">
                    Enviar
                    Arquivos
                  </base-button>
                  <!--                  <base-button native-type="submit"  type="danger" class="my-4">Sair</base-button>-->
                  <modal :show.sync="modal1">
                    <h6 slot="header" class="modal-title" id="modal-title-default">Erro ao protocolar envio de
                      arquivo</h6>

                    <h5 v-if="erro_escolha">É necessário escolher uma pontuação!</h5>
                    <b v-if="erro_escolha">É Clique em "Clique para Escolher" para escolher uma pontuação </b>

                    <br>

                    <h5 v-if="erro_sem_arquivos">Nenhuma imagem foi selecionada!</h5>
                    <b v-if="erro_sem_arquivos">É necessário clicar na área indicada para selecionar os arquivos que
                      deseja enviar.</b>

                    <div v-if="erros_validacao.length>0">
                      <h4>Erros encontrados</h4>
                      <div v-for="erro in erros_validacao" :key="erro"><br>{{ erro }}</div>

                      <br>
                      <h5>Corrija os erros acima e clique em <b>Enviar Arquivos</b> para tentar novamente </h5>

                    </div>


                    <template slot="footer">
                      <base-button type="link" class="ml-auto" @click="modal1 = false">Voltar
                      </base-button>
                    </template>
                  </modal>

                  <loading :active="isLoading" :can-cancel="false" :is-full-page="true"/>


                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Modal from '../components/Modal';
import axios from "axios";
import BaseDropdown from "@/components/BaseDropdown";
import ExpProInput from "@/components/ExpProInput";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data: function () {
    return {
      sejuf_area: {},
      sejuf_area_escolhida: {},

      isLoading: false,
      dropzoneOptions_array: [],
      registros: {},
      pontuacao_escolhida: {},
      estrutura_titulos: {},
      dados_candidato: {},
      dados_concurso: {},
      file: "",
      protocolo_gerado: '',
      modal1: false,
      btnConfirmacao: false,
      erro_sem_arquivos: false,
      erros_validacao: [],
      erro_escolha: false,
      dropzoneOptions: {
        timeout: 100000000000,
        url: this.$http.defaults.baseURL + '/titulos/upload_files',
        thumbnailWidth: 150,
        maxFilesize: 4.2,
        dictRemoveFile: "Remover",
        addRemoveLinks: true,
        acceptedFiles: 'image/jpg,image/jpeg,image/png,application/pdf',
        autoProcessQueue: false,
        dictDefaultMessage: "Clique ou arraste para enviar arquivos",
        headers: {token: localStorage.getItem('token'), tipoarquivo: '', protocolo: '', origemarquivo: 'titulos'},
        // params: {extra:{}}
      },
      bloqueia_requisito: ''
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    Modal: Modal,
    BaseDropdown: BaseDropdown,
    ExpProInput: ExpProInput,
    Loading,
  },
  beforeMount() {
    (async () => {

      //Popula dados do concurso;
      let token = localStorage.getItem('token');
      let concurso = localStorage.getItem('concurso');
      localStorage.setItem('origem_arquivo', 'titulos');

      try {
        let response = await axios.get('/form/info_concurso', {params: {token, concurso}})
        this.dados_concurso = response.data;

        response = await axios.get('/form/info_candidato', {params: {token, concurso}})
        this.dados_candidato = response.data;

        // response = await axios.get('/form/info_protocolo', {params: {token, concurso}});
        // this.protocolo_gerado = response.data.protocolo;
        this.protocolo_gerado =  `${this.dados_candidato.num_cand}|${parseInt(parseInt(this.dados_candidato.num_cand.replace("-",''))*3.14*parseInt(new Date().toISOString().substring(14,2)))}`
        sessionStorage.setItem('protocolo', this.protocolo_gerado);


        response = await axios.get('/titulos', {params: {token, concurso}})
        this.estrutura_titulos = response.data.titulos;

        //Verifica se tem requisito
        for (let item of this.estrutura_titulos.estrutura) {
          if (item.id === 'requisito') {
            this.bloqueia_requisito='everything'
          }
        }

        for (let item of this.estrutura_titulos.estrutura) {
          this.dropzoneOptions_array.push({id: item.id, dropzoneOptions: this.dropzoneOptions});
        }

      } catch (error) {
        await this.$router.push('/login/' + concurso + '?login=titulos');
      }

    })();

  },
  watch: {
    pontuacao_escolhida: {
      handler(newValue) {

        if (newValue.requisito && newValue.requisito.pontos === 0)
            // this.bloqueia_requisito = 'everything'
          this.bloqueia_requisito = ''
        else
          this.bloqueia_requisito = ''

        console.log(newValue, this.bloqueia_requisito)

      }, deep: true
    }
  },
  methods: {
    //Concurso EBESERH 2204 que tem pre-requisitos
    //Funcao utilizada para borrar os campos enquanto não subir um requisito
    checa_requisito(titulo, remove) {
      return false;
      if (remove)
        return false
      if (titulo !== 'requisito' && this.dados_concurso.concurso === '2204T')
        return true;
      return true;
      return false;
    },
    valida_campos_antes_envio() {
      //Verifica se existem titulos sem pontuacao ou sem arquivos

      let erro = []
      for (let titulo of this.estrutura_titulos.estrutura) {

        if ((this.pontuacao_escolhida[titulo.id] === undefined)
            && this.$refs[`drop_titulo_${titulo.id}`][0].getQueuedFiles().length > 0) {
          // alert(`${titulo.id} Nao pontuado e com arquivo tipo 1`);
          erro.push(`Falta escolher pontuação em ${titulo.nome}`)
        }

        // if ((this.pontuacao_escolhida[titulo.id] !== undefined && this.pontuacao_escolhida[titulo.id].pontos == 0)
        //     && this.$refs[`drop_titulo_${titulo.id}`][0].getQueuedFiles().length > 0)
        //   alert(`${titulo.id} Nao pontuado e com arquivo tipo 2`)

        if ((this.pontuacao_escolhida[titulo.id] !== undefined && this.pontuacao_escolhida[titulo.id].pontos != 0)
            && this.$refs[`drop_titulo_${titulo.id}`][0].getQueuedFiles().length === 0) {
          // alert(`${titulo.id} pontuado e sem arquivo`)
          erro.push(`Falta anexar arquivos em ${titulo.nome}`)
        }
      }

      return erro;
    },

    seta_pontuacao(id, pontos) {
      this.$set(this.pontuacao_escolhida, id, pontos);
      //Colocando a pontuacao no array principal tbm
      for (let [index, item] of this.estrutura_titulos.estrutura.entries()) {
        if (item.id === id) {
          this.estrutura_titulos.estrutura[index].pontuacao_escolhida = pontos.pontos;
        }
      }
    },

    seta_pontuacao_2002_sejuf(id, tipo) {
      this.$set(this.sejuf_area, id, tipo);
      // //Colocando a pontuacao no array principal tbm
      for (let [index, item] of this.estrutura_titulos.estrutura.entries()) {
        if (item.id === id) {
          this.sejuf_area_escolhida[id] = tipo
        }
      }
    },

    async envia_arquivos() {
      const sleep = async (time) => {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve()
          }, time)
        })
      }

      //chama validacao
      let erros_validacao = this.valida_campos_antes_envio();
      if (erros_validacao.length > 0) {
        this.erros_validacao = erros_validacao;
        this.modal1 = true;
        return;
      }


      let arquivos_na_fila = 0;
      for (let titulo of this.estrutura_titulos.estrutura) {
        arquivos_na_fila += this.$refs[`drop_titulo_${titulo.id}`][0].getQueuedFiles().length;
      }

      if (arquivos_na_fila == 0) {
        this.modal1 = true
        this.erro_sem_arquivos = true
        return
      }
      this.erro_sem_arquivos = false;


      //Atualiza para cada tipo de titulo o protocolo e o cargo
      for (let titulo of this.estrutura_titulos.estrutura) {
        for (let [index, drop] of this.dropzoneOptions_array.entries()) {
          if (drop.id === titulo.id) {
            this.dropzoneOptions_array[index].dropzoneOptions.headers.protocolo = this.protocolo_gerado;
            this.dropzoneOptions_array[index].dropzoneOptions.headers.idcargo = this.estrutura_titulos.id_cargo;
            this.dropzoneOptions_array[index].dropzoneOptions.headers.idcargo = this.estrutura_titulos.id_cargo;
          }
        }
      }

      this.isLoading = true;
      //Atualiza para cada tipo de titulo a pontuacao escolhida e o tipo de título
      for (let titulo of this.estrutura_titulos.estrutura) {
        for (let [index, drop] of this.dropzoneOptions_array.entries()) {

          if (drop.id === titulo.id) {
            this.dropzoneOptions_array[index].dropzoneOptions.headers.tipoarquivo = titulo.id;
            this.dropzoneOptions_array[index].dropzoneOptions.headers.pontuacaopedida = titulo.pontuacao_escolhida;
            console.log(`Enviando os títulos...`)
            await sleep(1000);
            //Envia o arquivo
            await this.$refs[`drop_titulo_${titulo.id}`][0].processQueue();
          }
        }
      }

      const interval = setInterval(async () => {

        let drops = [];
        for (let titulo of this.estrutura_titulos.estrutura) {
          // this.dropzoneOptions.headers.tipoarquivo = titulo.id;
          drops.push(this.$refs[`drop_titulo_${titulo.id}`][0].dropzone.files);
        }

        let flag = true;
        const verifica_arquivos = (drop) => {
          for (let item of drop) {
            console.log(item)
            if (item.status !== 'success') {
              flag = false;
            }
          }
        }

        for (let drop of drops) {
          verifica_arquivos(drop)
        }
        if (flag) {
          clearInterval(interval);

          return await this.$router.push('/protocolotitulos');

        }
      }, 2000)

      // await this.$router.push('/protocolo');

    }
    ,
    atualiza_registros(titulo_id, registro) {
      this.registros[titulo_id] = registro

    }
    ,
    fileAdded(titulo_id, file, xhr, formData) {
      console.log(`enviando info nova`, titulo_id, file, xhr, formData);
      formData.append('extra', JSON.stringify({
        registros: this.registros[titulo_id],
        extra: this.sejuf_area_escolhida[titulo_id]
      }));
      formData.append('pontuacao_pedida', this.pontuacao_escolhida[titulo_id].pontos);
      formData.append('tipoarquivo', titulo_id);
    }

  }
  ,

}
;
</script>
<style scoped>
.file-name {
  margin: 5px;
}

/*.profile-page {*/
/*  height: 5000px;*/
/*}*/
.everything {
  filter: blur(3px) grayscale(100%);
  opacity: 0.6
}
</style>
